module.exports = __webpack_public_path__ + "static/media/icon_99.cdb2c653.svg";